export default __webpack_public_path__ + "imgs/toLove04.f1d486e.jpeg";